import React from "react";
import { MdOutlineCancel } from "react-icons/md";
import {
    Box,
    Button,
    Typography,
    CircularProgress,
} from "@mui/material";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { useCreateStore } from "../../../services/stores";
import ModalLayout from "../../../components/modals/Layout";


const CreateStore = ({ visible, handleCancelButton, restaurant_id }) => {
    const [values, setValues] = React.useState({
        store_name: "",
        location: "",
    });

    const { store_name, location } = values;

    const { mutate: createStore, isLoading } = useCreateStore(restaurant_id);

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!store_name || !location) return;

        createStore(
            {
                name: store_name,
                location,
                restaurant: restaurant_id,
            },
            {
                onSuccess: () => {
                    handleCancelButton(); // close modal after success
                },
            }
        );
    };

    return (

        <ModalLayout open={visible} setOpen={handleCancelButton} title={'Create Store'}>
            {/* Form */}
            <ValidatorForm onSubmit={handleSubmit} autoComplete="off">
                <div className="border-t pt-5 space-y-4">
                    <Box>
                        <Typography>Store Name</Typography>
                        <TextValidator
                            fullWidth
                            value={store_name}
                            onChange={handleChange("store_name")}
                            validators={["required"]}
                            errorMessages={["Store name is required"]}
                        />
                    </Box>

                    <Box>
                        <Typography>Location</Typography>
                        <TextValidator
                            fullWidth
                            value={location}
                            onChange={handleChange("location")}
                            validators={["required"]}
                            errorMessages={["Location is required"]}
                        />
                    </Box>

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        disabled={isLoading}
                        sx={{ mt: 3, color: "white", fontSize: "1rem" }}
                    >
                        {isLoading ? (
                            <CircularProgress size={22} sx={{ color: "white" }} />
                        ) : (
                            "Create Store"
                        )}
                    </Button>
                </div>
            </ValidatorForm>
        </ModalLayout>

    );
};

export default CreateStore;
